Vendd.Scripts.load(function () {
    var $wrapper = $('.x-searchbox.elastic');

    if ($wrapper.length < 1)
        return;

    $.each($wrapper, function (i, wrapper) {
        var $wrapper = $(wrapper);

        var netSiteUrl = $wrapper.data('netsite-url');
        var $input = $('.js-keyword', $wrapper);
        $input.val("");
        var $button = $('.js-submit', $wrapper);
        var $openButton = $('.js-open-search');
        var $toggleButton = $('.js-search-toggle', $wrapper);
        var minLength = $wrapper.data('min-search-length');
        var showOnlyProducts = $wrapper.data('only-products');
        var mask = $wrapper.data('mask');

        var ajax = $wrapper.data('ajax');
        if (typeof ajax === 'string')
            ajax = ajax.trim().toLowerCase() === 'true';

        var $elastic, model = {}, searchTerm = "";

        if (ajax) {
            $elastic = $(".x-elastic-results-list", $wrapper);

            if ($elastic.length <= 0)
                throw 'Error: Elastic List does not exist';

            Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetProductElasticResultsFailed, wrapper, function (envelope) {
                model.products = null;
                wrapper.loading(false);
            });

            Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetProductElasticResultsSuccess, wrapper, function (envelope) {
                if (envelope.message.data.sender != wrapper) return;

                model.products = envelope.message.data.model;
                wrapper.render();
            });
        }

        wrapper.render = function () {
            if (!model.products) return;
            if (!model.articles) return;

            wrapper.bind();

            if (model.products.hits.hits.length < 1)
                $('.no-results.results', $elastic).addClass('visible');

            setTimeout(function () { $elastic.removeClass('loading'); }, 50);
        };

        wrapper.bind = function () {
            var html = Vendd.Handlebars.parse("elasticResultList_JET", model);
            $elastic.html(html);

            Vendd.MessageBus.publishAsync($elastic.get(0), new Vendd.Widget.Messages.BindControl($elastic));

            $('.js-show-elastic-results', $elastic).click(function (e) {
                e.preventDefault;
                wrapper.submit();
            });

            $('.js-show-netsite-results', $elastic).click(function (e) {
                e.preventDefault;

                window.location.href = netSiteUrl + '/search?Terms=' + searchTerm;
            });

            wrapper.showList(true);
            wrapper.loading(false);
        };

        wrapper.loading = function (loading) {
            if (loading) {
                $wrapper.addClass('x-loading').addClass('x-disabled');
            } else {
                $wrapper.removeClass('x-loading').removeClass('x-disabled');
            }
        };

        wrapper.clearValue = function () {
            $input.val("");
        };

        wrapper.checkSearchTerm = function () {
            return /[a-zα-ωάέήίόύώϊϋΐΰςа-я0-9]+/i.test(searchTerm);
        };

        wrapper.showList = function (show) {
            if (ajax && $elastic.length > 0) {
                if (show) {
                    $elastic.addClass('js-visible');
                    $wrapper.addClass('overlaid');
                } else {
                    $wrapper.removeClass('overlaid');
                    $elastic.removeClass('js-visible');
                }
            }
        };

        wrapper.submit = function () {
            var searchTerm = $input.val();
            var targetUrl = mask.replace("((search))", encodeURIComponent(searchTerm));
            if (showOnlyProducts)
                targetUrl = targetUrl.replace('/search/', '/search-products/');

            document.location = targetUrl;
        };

        wrapper.expand = function () {
            if ($wrapper.hasClass('expanded')) {
                $wrapper.removeClass('expanded');
                $button.trigger('click');
            } else {
                $wrapper.addClass('expanded');
                $input.focus();
                if ($input.val().length >= minLength && wrapper.checkSearchTerm()) {
                    if (ajax) {
                        wrapper.showList(true);
                    }
                }
            }

        };

        wrapper.initSearch = function () {
            if (searchTerm != $input.val()) {
                searchTerm = $input.val();

                if (searchTerm.length >= minLength && wrapper.checkSearchTerm()) {
                    if (ajax) {
                        wrapper.loading(true);
                        wrapper.showList(true);

                        model.products = null;
                        model.articles = null;
                      
                        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetProductElasticResults(searchTerm));

                        wrapper.getNetSiteSearchResults(searchTerm);
                    }
                } else {
                    wrapper.showList(false);
                }
            }
        };

        wrapper.getNetSiteSearchResults = function (searchTerm) {        
            $.ajax({
                type: "POST",
                dataType: 'json',
                contentType: 'application/json; charset=UTF-8',
                url: netSiteUrl + '/api/queries/FullTextSearch',
                async: false,
                data: JSON.stringify({ term: searchTerm, language: LhApp.Context.Language }),
                success: function (data) {
                    console.log(data);
                    if (data) {
                        model.articles = data;
                        model.NetSiteUrl = netSiteUrl;
                        wrapper.render();
                    }                       
                },
                error: function (data) {
                    console.log('Error getting search results from NetSite API');
                }
            });
        };

        $input.keyup($.debounce(500, function (e) {
            wrapper.initSearch();
        }));

        $input.bind('paste', function (e) {
            if (!e.keyCode) {
                setTimeout(function () {
                    wrapper.initSearch();
                }, 10);
            }
        });

        $input.keyup(function (e) {
            if (e.keyCode === 13 && $input.val().length >= minLength && wrapper.checkSearchTerm()) {
                wrapper.submit();
            }
            if (searchTerm == $input.val()) {
                $elastic.removeClass('loading');
            }
            else {
                $elastic.addClass('loading');
            }
        });

        $input.click(function (e) {
            if (searchTerm.length >= minLength && wrapper.checkSearchTerm()) {
                if (ajax) {
                    wrapper.showList(true);
                }
            } else {
                wrapper.showList(false);
            }
        });
   
        $button.click(function (e) {
            e.preventDefault();
            if ($wrapper.hasClass('overlaid')) {
                wrapper.showList(false);
            } else {
                if ($input.val().length >= minLength && wrapper.checkSearchTerm()) {
                    if (ajax) {
                        wrapper.showList(true);
                    }
                }
                $input.focus();
            }
        });

        $toggleButton.click(function (e) {
            if ($wrapper.hasClass('visible')) {
                $wrapper.removeClass('visible');

                $('html').removeClass('no-scroll');
                $('.header-region').removeClass('active clean-zindex');
                $('.header-overlay').removeClass('visible');
            } else {
                $wrapper.addClass('visible');

                $('html').addClass('no-scroll');
                $('.header-region').addClass('active clean-zindex');
                $('.header-overlay').addClass('visible');
            }
        });

        $openButton.click(function (e) {
            if ($wrapper.hasClass('visible')) {
                $wrapper.removeClass('visible');

                $('html').removeClass('no-scroll');               
                $('.header-region').removeClass('active clean-zindex');
                $('.header-overlay').removeClass('visible');
            } else {
                $wrapper.addClass('visible');

                $('html').addClass('no-scroll');           
                $('.header-region').addClass('active clean-zindex');
                $('.header-overlay').addClass('visible');
            }
        });

        $('.header-overlay').on('click', function (e) {
            e.preventDefault();

            $wrapper.removeClass('visible');

            $('html').removeClass('no-scroll');          
            $('.header-region').removeClass('active clean-zindex');
            $('.header-overlay').removeClass('visible');
        });

        $(document).keyup(function (e) {
            if (e.keyCode == 27 && $wrapper.hasClass('overlaid')) {
                $wrapper.removeClass('expanded');
                wrapper.showList(false);
            }
        });

    });

});
